import { ArrowCircleRight } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { toastifyService } from '@services/ToastifyService';
import darkTheme from '@shared/themes/darkTheme';
import { useState } from 'react';
import { WatchlistEntry } from './WatchlistTypes';
import { Slide } from 'react-toastify';

const WatchlistToast = (props: { entry: WatchlistEntry; addWidgetCallback: (entry: WatchlistEntry) => void }) => {
  const { tenor, symbol, targetPrice } = props.entry;

  const [hovered, setHovered] = useState(false);

  const colour = hovered ? darkTheme.palette.success.dark : 'inherit';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
      <Typography
        onMouseEnter={() => {
          setHovered(true);
        }}
        onMouseLeave={() => {
          setHovered(false);
        }}
        onClick={() => {
          props.addWidgetCallback(props.entry);
        }}
        sx={{ cursor: 'pointer', flexGrow: 1, display: 'flex', transition: 'all 0.2s ease', color: colour }}
      >
        <span style={{ flexGrow: 1 }}>
          {symbol.toUpperCase()} {tenor.toUpperCase()} has reached {targetPrice.toFixed(2)}
        </span>
        <ArrowCircleRight sx={{ minWidth: 0, marginRight: '10px', transition: 'all 0.2s ease', color: colour }} />
      </Typography>
    </Box>
  );
};

export const showWatchlistToast = (watchlistEntry: WatchlistEntry, callback: (entry: WatchlistEntry) => void) => {
  toastifyService.showCustomToast(<WatchlistToast entry={watchlistEntry} addWidgetCallback={callback} />, {
    autoClose: 5000,
    closeButton: false,
    transition: Slide,
  });
};
